export const dataDB = {
  data() {
    return {
      dataDB: {
        employees: [
          // 1 Administración
          // 2 Gestión
          // 3 Ventas
          { id:  1, roleID: 1, role: 'Administración', name: 'Lisandro Dalla Costa',   nick: 'Licha',   user: 'LichaDC',       password: 'licha567'         },
          { id:  2, roleID: 1, role: 'Administración', name: 'Lautaro Dalla Costa',    nick: 'Lau',     user: 'LautaDC',       password: '34770668'         },
          { id:  3, roleID: 2, role: 'Ventas',         name: 'Luisina Favre',          nick: 'Lui',     user: 'LuisiFavre',    password: 'RapiLuiSuper'     },
          { id:  4, roleID: 3, role: 'Ventas',         name: 'Luciano Leiva',          nick: 'Lucho',   user: 'LuchoLeiva',    password: 'lucholeiva567'    },
          { id:  5, roleID: 2, role: 'Gestión',        name: 'Melina Barbaglia',       nick: 'Meli',    user: 'MeliB',         password: 'meliB567'         },
          { id:  6, roleID: 2, role: 'Gestión',        name: 'Alexis Cassini',         nick: 'Ale',     user: 'AleCa',         password: 'AleCassini567'    },
          { id:  7, roleID: 3, role: 'Ventas',         name: 'Sai García',             nick: 'Sai',     user: 'SaiGarcia',     password: 'Saigarcia16'      },
          { id:  8, roleID: 1, role: 'Administración', name: 'Silvia Hofer',           nick: 'Silvi',   user: 'Silvita',       password: 'lisandroElMejor'  },
          { id:  9, roleID: 1, role: 'Administración', name: 'Marcelo Dalla Costa',    nick: 'Marce',   user: 'Marcelito',     password: 'miHijoManda'      },
          { id: 10, roleID: 3, role: 'Ventas',         name: 'Francisco Nierenberger', nick: 'Fran',    user: 'FranN',         password: 'Fran567N'         },
          { id: 11, roleID: 3, role: 'Ventas',         name: 'Vale Notta',             nick: 'Vale',    user: 'ValeNotta',     password: 'Vale567N'         },
          { id: 12, roleID: 3, role: 'Ventas',         name: 'Mauro Boasso',           nick: 'Maurito', user: 'MauritoBoasso', password: 'MauRoBo'          },
          { id: 13, roleID: 3, role: 'Ventas',         name: 'Priscila Garoni',        nick: 'Prisi',   user: 'PrisiG',        password: 'Prisi567G'        },
          { id: 14, roleID: 3, role: 'Ventas',         name: 'Federico Hammerly',      nick: 'Fede',    user: 'FedeHam',       password: 'FedeRapiSu'       },
          { id: 15, roleID: 3, role: 'Ventas',         name: 'Matías Rossetti',        nick: 'Pocho',   user: 'PochoRoss',     password: 'RapiPochoSuper'   },
          { id: 16, roleID: 3, role: 'Ventas',         name: 'Matías Bonthuis',        nick: 'Mati',    user: 'MatiBonthuis',  password: 'MatiSuperRapi'    },
          { id: 17, roleID: 3, role: 'Ventas',         name: 'Leandro Gaitán',         nick: 'Bocha',   user: 'BochaG',        password: 'RapiSuperBocha'   },
          { id: 18, roleID: 3, role: 'Ventas',         name: 'Dino Dichiara',          nick: 'Dino',    user: 'DinoDi',        password: '567DinoDi'        },
          { id: 19, roleID: 3, role: 'Ventas',         name: 'Nicolás Ubait',          nick: 'Nico',    user: 'NicoUbait',     password: 'NicoNico567'      },
          { id: 20, roleID: 3, role: 'Ventas',         name: 'Paola Ferrari',          nick: 'Pao',     user: 'PaoFerrari',    password: 'PaolaSuperRapi'   },
          { id: 21, roleID: 3, role: 'Ventas',         name: 'José Regner',            nick: 'José',    user: 'JoseRegner',    password: 'RapisuperRegJose' },
          { id: 22, roleID: 3, role: 'Ventas',         name: 'Lautaro Scaglia',        nick: 'Lauti',   user: 'LautiSca',      password: 'Rapi567Lauti'     },
          { id: 23, roleID: 3, role: 'Ventas',         name: 'Juan Merlo',             nick: 'Juan',    user: 'JuanMerlo',     password: 'JuanRapiMerlo'    },
          { id: 24, roleID: 3, role: 'Ventas',         name: 'Santiago Hug',           nick: 'Santi',   user: 'SantiHug',      password: 'SantI567huG'      },
          { id: 25, roleID: 3, role: 'Ventas',         name: 'Lucas Hammerly',         nick: 'Lucas',   user: 'LucasHam',      password: 'LuCasH5'          },
          { id: 26, roleID: 3, role: 'Ventas',         name: 'Hugo Gudiño',            nick: 'Hugo',    user: 'HugoG',         password: 'GudiHugoRapi'     },
          { id: 27, roleID: 3, role: 'Ventas',         name: 'Tadeo Bracamonte',       nick: 'Tadeo',   user: 'Tadeooo',       password: 'TadeoooSuperrapi' },
          { id: 28, roleID: 3, role: 'Ventas',         name: 'Ignacio Terisotto',      nick: 'Nacho',   user: 'NachoTeri',     password: '567NachoT'        },
          { id: 29, roleID: 3, role: 'Ventas',         name: 'Fabricio Martinelli',    nick: 'Fabri',   user: 'FabriM',        password: 'FaMarRapisuper'   },
        ],
        SaleStates: [
          /* 0 */ 'Desconocido',
          /* 1 */ 'Pedido',
          /* 2 */ 'En armado',
          /* 3 */ 'Armado',
          /* 4 */ 'En control',
          /* 5 */ 'Controlado',
          /* 6 */ 'En camino',
          /* 7 */ 'Entregado',
          /* 8 */ 'Con errores',
          /* 9 */ 'Cancelado',
        ],
        // SaleStates: {
        //   Desconocido: '0',
        //   Pedido: '1',
        //   Armado: '2',
        //   Enviado: '3',
        //   Entregado: '4',
        //   Cancelado: '5',
        // },
        SaleStateIDs: {
          Desconocido: 0,
          Pedido: 1,
          EnArmado: 2,
          Armado: 3,
          EnControl: 4,
          Controlado: 5,
          EnCamino: 6,
          Entregado: 7,
          ConErrores: 8,
          Cancelado: 9,
        },

        SaleProductsControlStateIDs: {
          pedido: 0,
          armado: 1,
          controlado: 2,
        },
        Cities: [
          { id: 1, name: 'San Carlos Centro'},
          { id: 2, name: 'San Carlos Sur'},
          { id: 3, name: 'San Carlos Norte'},
          { id: 4, name: 'Gessler'},
          { id: 5, name: 'Matilde'},
        ],
        SalePaymentTypeIDs: {
          Efectivo: 1,
          Tarjeta: 2,
          Mercadopago: 3,
          QR: 4,
        },
        ProductPickUpStateIDs: {
          SinEncargar: 0,
          Pedido: 1,
          Recibido: 2,
        },
        DaysOfWeekIDs: {
          domingo: 0, lunes: 1, martes: 2, miercoles: 3, jueves: 4, viernes: 5, sabado: 6,
        },
        SaleTypeIDs: { saleInPlace: 1, call: 2, whatsapp: 3, instagram: 4, facebook: 5, twitter: 6, other: 7, },
        saleTypes: [
          { id: 1, label: 'Venta en local', },
          { id: 2, label: 'Llamada telefónica', },
          { id: 3, label: 'Whatsapp', },
          { id: 4, label: 'Instagram', },
          { id: 5, label: 'Facebook', },
          { id: 6, label: 'Twitter', },
          { id: 7, label: 'Otra', },
        ],
        sellers: [
          { id:  1, name: 'Lisandro Dalla Costa',   nick : 'Licha', },
          { id:  2, name: 'Lautaro Dalla Costa',    nick : 'Lau', },
          { id:  3, name: 'Luisina Favre',          nick : 'Lui', },
          { id:  4, name: 'Luciano Leiva',          nick : 'Lucho', },
          { id:  5, name: 'Melina Barbaglia',       nick : 'Meli', },
          { id:  6, name: 'Alexis Cassini',         nick : 'Ale', },
          { id:  7, name: 'Sai García',             nick : 'Sai', },
          { id:  8, name: 'Silvia Hofer',           nick : 'Silvi', },
          { id:  9, name: 'Marcelo Dalla Costa',    nick : 'Marce', },
          { id: 10, name: 'Francisco Nierenberger', nick : 'Fran', },
        ],
        StockChangesWebsiteZoneIDs: {
          sale: 1,
          stockChangePrompt: 2,
          cancelSale: 3,
          addProduct: 4,
          modifyProductAmount: 5,
          changeProductBy: 6, // SIN CONTROLAR
          deleteProduct: 7,
          masiveStockChanger: 8, // SIN CONTROLAR
          forceSaleStockControl: 9,
        },
        accountingStates: {

        },
        SalesMistakesStateIDs: {
          SinResolver: 1,
          EnProceso: 2,
          Resuelto: 3,
        },
        SalesMistakesStates: [
          'Desconocido',
          'Sin resolver',
          'En proceso',
          'Resuelto',
        ],
      }
    } // return DATA
  } // DATA
} // export default
